module.exports = __webpack_public_path__ + "static/media/Service Record.97f3fac9.png";